import { IContactConnection, useGetConnectionsQuery } from "./contactConnectionsApi"
import { useEffect, useState } from "react"
import { useAuth } from "../../../modules/auth"

export const useContactConnections = () => {
    const { user, selectedEntityId: entityId, selectEntityId } = useAuth()
    const { data, isLoading } = useGetConnectionsQuery({ role: user?.role, contactId: user?.contactId || '' })
    const [connections, setConnections] = useState<IContactConnection[]>([])

    useEffect(() => {
        if (!data) return

        if (data.selectedEntityId) {
            selectEntityId(data.selectedEntityId)
        } else {
            if (data.connections.length === 1 && data.connections[0].contactId) {
                selectEntityId(data.connections[0].contactId)
            } else {
                setConnections(data.connections ?? [])
            }
        }

        // eslint-disable-next-line 
    }, [data, entityId])

    // console.log("entityId", entityId);

    // useEffect(() => {
    //     if (!user?.userId || !user.role) {
    //         return;
    //     }
    //     setLoading(true)

    //     getConnections({ role: user.role, contactId: user.userId })
    //         .unwrap()
    //         .then((result) => {
    //             if (result.length === 1) {
    //                 selectEntityId(result[0].contactId)
    //             } else {
    //                 setConnections(result)
    //             }
    //         })
    //         .catch((error) => {
    //             console.error(error)
    //         })
    //         .finally(() => setLoading(false))
    //     // eslint-disable-next-line
    // }, [user?.contactId, user?.role])

    return { connections, entityId, selectEntityId, loading: isLoading }
}
